import Challenge from './challenge'

let cf: Challenge | undefined = undefined

if (typeof document !== 'undefined') {
  // document is inherently client-side so document will be undefined on build on server-side render sites
  document.addEventListener('DOMContentLoaded', createChallenge)
}

export async function ready(callback: () => void): Promise<void> {
  await createChallenge()
  if (cf !== undefined) {
    callback()
  }
}

export async function execute(): Promise<string | undefined> {
  await render()
  if (cf !== undefined) {
    return cf.getPromise()
  }
}

async function render(): Promise<void> {
  await createChallenge()
  if (cf !== undefined) {
    cf.render()
  }
}

async function createChallenge(): Promise<void> {
  if (cf === undefined) {
    cf = new Challenge()
    await cf.initialize()
  }
}
